(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.TiktokPrivatePresence = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'TikTok private presence data',
            channelName: sourceDetails[sources.TIKTOK_INSIGHTS].name,
            postName: sourceDetails[sources.TIKTOK_INSIGHTS].postName,

            storageDimensions: [
                'companyId',
                'day'
            ],

            availableDimensions: [
                'companySetId',
                'week',
                'month'
            ],

            fields: {
                audience: {
                    name: 'Followers',
                    dataType: dataType.INTEGER
                },
                engagement_total: {
                    name: 'Engagement Total',
                    dataType: dataType.INTEGER
                },
                engagement_rate: {
                    name: 'Engagement Rate',
                    dataType: dataType.ABSOLUTE_PERCENT
                },
                net_followers: {
                    dataType: dataType.INTEGER
                },
                profile_views: {
                    dataType: dataType.INTEGER
                },
                likes: {
                    dataType: dataType.INTEGER
                },
                comments: {
                    dataType: dataType.INTEGER
                },
                shares: {
                    dataType: dataType.INTEGER
                },
                video_views: {
                    dataType: dataType.INTEGER
                },
                audience_activity: {
                    dataType: dataType.OBJECT
                },
                audience_countries: {
                    name: 'Country',
                    dataType: dataType.OBJECT
                },
                audience_genders: {
                    dataType: dataType.OBJECT
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.publicPost,
                DataSourceFilterGroupIds.timePeriod
            ]
        };
    }
})();
